<template>
  <div>
    <div class="ui form" v-if="reverse.response_data">
      <div class="ui dividing small header">
        {{ $t("automatic reverse due request error") }}
      </div>
      <div class="five fields">
        <div class="field">
          <label for="">{{ $t("audit number") }}</label>
          <input
            type="text"
            v-model="reverse.response_data.result.response.auditNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("reference number") }}</label>
          <input
            type="text"
            v-model="reverse.response_data.result.response.referenceNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("authorization number") }}</label>
          <input
            type="text"
            v-model="reverse.response_data.result.response.authorizationNumber"
          />
        </div>
        <div class="field">
          <label for="">{{ $t("response code") }}</label>
          <input
            type="text"
            v-model="reverse.response_data.result.response.responseCode"
          />
          <div class="field"></div>
        </div>
        <div class="field">
          <label for="">{{ $t("message type") }}</label>
          <input
            type="text"
            v-model="reverse.response_data.result.response.messageType"
          />
          <div class="field"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filters from "@/filters";
import { translate_status, translate_type } from "../local_translator";
import { cloneDeep } from "lodash";

filters.translate_status = translate_status;
filters.translate_type = translate_type;

export default {
  name: "VisaPaymentTransactionModalReverse",
  filters: filters,
  components: {},
  computed: {},
  props: { transaction: Object },
  data() {
    return {
      reverse: {},
    };
  },
  methods: {},
  mounted() {
    setTimeout(() => {
      let vm = this;
      if (
        vm.transaction &&
        vm.transaction.vis_reverses &&
        vm.transaction.vis_reverses.length
      ) {
        let clone = cloneDeep(vm.transaction.vis_reverses[0]);
        clone.request_data = JSON.parse(clone.request_data);
        clone.response_data = JSON.parse(clone.response_data);
        this.reverse = clone;
      }
    }, 1000);
  },
  watch: {},
  updated: function() {},
};
</script>
